import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  error: {
    id: 'studio.yjZtkP',
    defaultMessage: 'There was a problem loading the apps. Please try reloading the page.',
  },
  allApps: {
    id: 'studio.ApTgM/',
    defaultMessage: 'All apps',
  },
  myApps: {
    id: 'studio.TnPYbz',
    defaultMessage: 'My apps',
  },
});
